/**
 * A curryied helper for getting the function you call to delete a pill
 */
export function getRemove<T>(onChange: (_: T[]) => void, index: number, pillValues: T[] | undefined) {
  return () => {
    if (!pillValues) {
      return;
    }
    const newPillValues = [...pillValues];
    if (index >= pillValues.length) {
      return;
    }
    newPillValues.splice(index, 1);
    onChange(newPillValues);
  };
}

/**
 * A curryied helper for getting the function you call to add a new pill
 */
export function getAppend<T>(onChange: (_: T[]) => void, pillValues: T[] | undefined, pillValue: T) {
  return () => {
    const newPillValues = pillValues ? [...pillValues] : [];
    newPillValues.push(pillValue);
    onChange(newPillValues);
  };
}

/**
 * A curryied helper for getting the function you call to update an existing pill
 */
export function getUpdate<T>(onChange: (_: T[]) => void, index: number, pillValues: T[] | undefined) {
  return (pillValueFields: Partial<T>) => {
    if (!pillValues || index >= pillValues.length) {
      return;
    }
    const newPillValue = { ...pillValues[index], ...pillValueFields };

    const newPillValues = [...pillValues];
    newPillValues[index] = newPillValue;
    onChange(newPillValues);
  };
}
